export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10840.7828e561.jpg";